import { Component, Input, OnInit } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';
import { Ga4Service } from '@services/ga4.service';
import { Store } from '@ngrx/store';
import { toggleFilter } from '@results/store/results.actions';
// import { ToggleFilter } from '@results/store/results.actions';
import { IResults } from '@results/store/results.state';
import { MbPaginator } from '@am/moebius';

@Component({
  selector: 'am-paginator',
  standalone: true,
  styleUrls: ['./paginator.component.scss'],
  templateUrl: './paginator.component.html',
  imports: [MbPaginator],
})
export class PaginatorComponent implements OnInit {
  @Input()
  public pagination: any;

  constructor(
    private store$: Store<IResults>,
    private analyticsService: AnalyticsService,
    private ga4Service?: Ga4Service,
  ) {}

  public ngOnInit() {
    this.setCurrentPage(this.pagination);
  }

  public setCurrentPage(pagination) {
    const currentPage = (pagination.offset ? pagination.offset : 0) / pagination.limit + 1;
    this.pagination = {
      ...pagination,
      current: Math.floor(currentPage),
    };
  }

  public updatePage(page) {
    const offset = { offset: (page - 1) * this.pagination.limit };
    this.trackPagination(page);
    this.store$.dispatch(toggleFilter({ payload: offset }));
  }

  private trackPagination(page) {
    this.analyticsService.trackEvent({
      action: 'Page-change',
      label: page,
      section: 'Results',
    });
    this.ga4Service?.user_interaction(
      { type: 'button', label: `pagina ${page}`, action: 'click', section: 'paginado' },
      'PLP',
    );
  }
}
